<template>
  <div class="component-wrapper">
    <div class="wheel__controls" id="wheel">
      <button class="wheel__directional-control" @click="handleMove('down')" aria-label="next">
        <Icon v-if="desktop" icon="arrow-up" />
        <Icon v-else icon="arrow-left" />
      </button>
      <button class="wheel__spin-control" @click="spin" aria-label="spin">
        <!-- <Icon v-if="desktop" icon="spin-desktop" /> -->
        <div v-if="desktop">
          <img src="https://s3.us-east-2.amazonaws.com/afh-www/site/assets/AwayFromHome/Campaigns/Jif-Tool/spin-desktop.png" alt="Spin">
        </div>
        <Icon v-else icon="spin-mobile" />
      </button>
      <button class="wheel__directional-control" @click="handleMove('up')" aria-label="previous">
        <Icon v-if="desktop" icon="arrow-down" />
        <Icon v-else icon="arrow-right" />
      </button>
    </div>
    <div class="wheel__wrapper">
      <ul v-if="filteredItems.length > 0" class="wheel" id="results" aria-live="polite">
        <li v-for="(item, index) in onScreenItems" :key="index" :class="(active ? 'active' : '') + ' ' + (direction) + ' ' + ((item) ? (item.Daypart) : '')">
          <button :class="itemClass(index)" @click="handleItemClick(index)" type="button" v-if="item">
            <div :class="{ 'wheel__image': true, 'new': isImageNew(index), 'done': !active }">
              <img v-if="desktop"
                :src="item.PreparedImageDesktop"
                alt=""
              >
              <img v-else
                :src="item.PreparedImageMobile"
                alt=""
              >
            </div>
            <div v-if="index === 3 && item.Daypart == 'Snack'" :class="{ 'wheel__category': true }">
              Starters/Sides
            </div>
            <div v-else-if="index === 3 && item.Daypart == 'Dinner'" :class="{ 'wheel__category': true }">
              Lunch/Dinner
            </div>
            <div v-else-if="index === 3 && item.Daypart != 'Dinner'" :class="{ 'wheel__category': true, 'wheel__category--red': item.Daypart === 'Breakfast' }">
              {{ item.Daypart }}
            </div>
          </button>
        </li>
      </ul>
      <!-- <ul class="wheel--shadow">
        <li v-for="(item) in onScreenItems" :key="item.key"></li>
      </ul> -->
    </div>
  </div>
</template>

<script>
import { gsap } from 'gsap'
import debounce from 'lodash.debounce'

import Icon from './Icon'

export default {
  components: {
    Icon,
  },
  name: 'Wheel',
  data() {
    return {
      size: 5,
      start: 0,
      direction: '',
      ready: false,
      desktop: false,
      active: false,
      repeats: 0,
      spinning: false,
      selectedItem: {},
      recordSpin: true,
    }
  },
  props: {
    controls: {
      type: Array,
      default: () => [],
    },
    filteredItems: {
      type: Array,
      default: () => []
    },
    settings: {
      type: Object,
      default: () => {}
    },
  },
  watch: {
    controls: {
      // this.itemSelection(this.onScreenItems[3])
      handler() {
        this.recordSpin = false
        this.spin()
        this.recordSpin = true
      },
      deep: true
    }
  },
  mounted() {
    window.addEventListener("resize", this.onResize)
    this.onResize()
    const urlParams = new URLSearchParams(window.location.search);
		const frame = urlParams.get('frame');
    if (frame) {
      this.desktop = true
      // force desktop mode so that the page doesn't scroll
    }
  },
  updated() {
    this.itemSelection(this.onScreenItems[3]);
  },
  destroyed() {
    window.removeEventListener("resize", this.onResize);
  },
  computed: {
    onScreenItems() {
      let smallerArray = this.filteredItems.slice(this.start, this.size);
      smallerArray.push('')
      smallerArray.unshift('')
      return smallerArray
    },
  },
  methods: {
    spin() {
      this.mobileScroll()
      this.spinning = true
      this.repeats = this.randomInt(5, 13)
      this.animate('up', 'fast')
      gsap.set('.wheel', { y: 0 })
      if (typeof dataLayer === 'object' && this.recordSpin) {
				// eslint-disable-next-line
				dataLayer.push({
					event: 'genericEvent',
					eventCat: 'Jif Tool',
					eventAction: 'click',
					eventLabel: 'Spin',
				});
			}
    },
    handleMove(direction) {
      this.mobileScroll()
      this.repeats = 0
      this.animate(direction, 'slow')
      this.spinning = false
      if (typeof dataLayer === 'object') {
				// eslint-disable-next-line
				dataLayer.push({
					event: 'genericEvent',
					eventCat: 'Jif Tool',
					eventAction: 'click',
					eventLabel: direction,
				});
			}
    },
    animate(direction, speed) {
      this.direction = direction
      this.active = true
      let duration = speed === 'fast' ? 0.066 : 0.8
      if (direction === 'up') {
        if (this.desktop) {
          gsap.to('.wheel', { y: '-20vh', duration: duration, onComplete: this.handleComplete, onRepeat: this.handleRepeat, clearProps: 'y', repeat: this.repeats, ease: 'back.inOut(1.2)'});
        } else {
          gsap.to('.wheel', { x: '-33.333vw', duration: duration, onComplete: this.handleComplete, onRepeat: this.handleRepeat, clearProps: 'x', repeat: this.repeats, ease: 'back.inOut(1.2)' });
        }
      } else {
        if (this.desktop) {
          gsap.to('.wheel', { y: '20vh', duration: duration, onComplete: this.handleComplete, onRepeat: this.handleRepeat, clearProps: 'y', repeat: this.repeats, ease: 'back.inOut(1.2)'});
        } else {
          gsap.to('.wheel', { x: '33.333vw', duration: duration, onComplete: this.handleComplete, onRepeat: this.handleRepeat, clearProps: 'x', repeat: this.repeats, ease: 'back.inOut(1.2)' });
        }
      }
    },
    handleRepeat() {
      this.incrementOnce()
    },
    handleComplete() {
      if (this.repeats <= 0) {
        this.incrementOnce()
      }
      this.itemSelect()
    },
    incrementNth(number) {
      for (let i = number ; i <= number ; i++) {
        this.incrementOnce()
      }
    },
    incrementOnce() {
      if (this.direction === 'up') {
        let item = this.filteredItems.shift() // removes first item and returns it
        this.filteredItems.push(item) // put it at the end
      } else {
        let item = this.filteredItems.pop() // removes the last item and returns it
        this.filteredItems.unshift(item) // add to the beginning
      }
      this.active = false
    },
    itemSelect() {
      this.itemSelection(this.onScreenItems[3])
    },
    mobileScroll() {
      if (window && !this.desktop) {
        window.location.hash = 'wheel'
      }
    },
    reset() {
      this.ready = false
      this.repeats = 0
      this.active = false
    },
    randomInt(start, end) {
      let randomNum = Math.floor(Math.random() * end) + start
      if (randomNum % this.filteredItems.length >= 1) {
        // if the random number is divisible by the length of the items array, it'll shuffle the whole array back to it's start, so it won't animate
        return randomNum
      } else {
        return randomNum + 1
      }
    },
    itemSelection: function(item) {
      this.selectedItem = item
      this.$emit('selection', item)
    },
    handleItemClick: function(index) {
      this.repeats = 0
      if (index === 1) {
        // this.spin(2)
        this.repeats = 1
        this.animate('down', 'slow')
      } else if (index === 2) {
        this.animate('down', 'slow')
      } else if (index === 4) {
        this.animate('up', 'slow')
      } else if (index === 5) {
        this.repeats = 1
        this.animate('up', 'slow')
      }
      this.repeats = 0
      if (typeof dataLayer === 'object') {
				// eslint-disable-next-line
				dataLayer.push({
					event: 'genericEvent',
					eventCat: 'Jif Tool',
					eventAction: 'click',
					eventLabel: 'Product Image',
				});
			}
    },
    isImageNew: function(index) {
      if (this.desktop) {
        return (this.direction === 'down' && index === 1) || (this.direction === 'up' && index === this.size) || this.spinning
      }
      else {
        return (this.direction === 'down' && index === 2) || (this.direction === 'up' && index === (this.size-1)) || this.spinning
      }
    },
    itemClass: function(index) {
      return ((this.direction === 'up' && index === 5 && this.ready) || (this.direction === 'down' && index === 1 && this.ready)) ? 'in' : 'out'
    },
    onResize: debounce(function() {
        if (window) {
          // return (window.innerWidth > 768) ? true : false
          this.desktop = window.matchMedia('(min-width: 1112px)').matches;
        } else {
          this.desktop = false
        }
    })
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

@import "../styles/_colors.scss";
@import "../styles/_variables.scss";
@import "../styles/vendor/_index.scss";

html {
  box-sizing: border-box;
}
*, *:before, *:after {
  box-sizing: inherit;
}

//! Desktop clip paths
$clipPosTwoOut: polygon(9% 0%, 91% 0%, 93% 100%, 6% 100%);
$clipPosTwo: polygon(6% 0%, 94% 0%, 97% 100%, 3% 100%);

$clipPosThree: polygon(3% 0%, 97% 0%, 100% 100%, 0% 100%);

$clipPosZero: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%);

$clipPosFive: polygon(0 0, 100% 0, 97% 100%, 3% 100%);

$clipPosSix: polygon(3% 0, 97% 0, 94% 100%, 6% 100%);
$clipPosSixOut: polygon(6% 0, 94% 0, 91% 100%, 9% 100%);

//! Mobile Clip Paths
$clipPosLeftOut: polygon(0 9%, 100% 6%, 100% 94%, 0 91%);
$clipPosLeft: polygon(0 6%, 100% 0, 100% 100%, 0 94%);

$clipPosRight: polygon(0 0, 100% 6%, 100% 94%, 0 100%);
$clipPosRightOut: polygon(0 6%, 100% 9%, 100% 91%, 0 94%);

.component-wrapper {
  display: flex;
  position: relative;
}

.wheel__controls {
  position: absolute;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  z-index: map-get($z, top);
  padding: 0;
  pointer-events: none;
  overflow: hidden;
  button:focus:not(:focus-visible) {
    outline: none;
  // box-shadow: 1px 1px 5px rgba(1, 1, 0, .7);
  }
  @include breakpoint(xmedium down) {
    left: 0;
    right: 0;
    width: 100%;
    top: -60px;
    align-items: flex-end;
  }
  @include breakpoint(large) {
    top: 0;
    height: 100%;
    width: auto;
    flex-direction: column;
    // top: calc(50% - 70px);
    left: -78px;
    align-items: center;
  }
}
.wheel__directional-control {
  pointer-events: all;
  width: 79px;
  height: 79px;
  transform: translateY(0) scale(1);
  transition: transform 300ms ease;
  padding: 10px;
  position: relative;
  svg {
    width: 100%;
    height: auto;
  }
  &:active:hover {
    transform: translateY(0.125em);
  }
  &:hover {
    transform: scale(1.1);
  }
  @include breakpoint(xmedium down) {
    bottom: 1em;
  }
  @include breakpoint(large) {
    left: 1.75em;
    bottom: auto;
  }
}
.wheel__spin-control {
  pointer-events: all;
  font-size: 2em;
  width: 110px;
  // background-color: tomato;
  // height: 3em;
  transform: translateY(0) scale(1);
  transition: transform 300ms ease;
  svg {
    width: 100%;
    height: auto;
  }
  &:active:hover {
    transform: translateY(0.125em);
  }
  &:hover {
    transform: scale(1.1);
  }
  @include breakpoint(large) {
    width: 175px;
  }
}

.wheel__wrapper {
  // position: fixed;
  position: relative;
  // right: calc(50% - 150px);
  width: 100%;
  @include breakpoint(xmedium down) { 
    overflow-x: hidden;
    overflow-y: visible;
  }
  @include breakpoint(large) {
    padding: 0 0.75em;
    overflow-y: hidden;
    overflow-x: visible;
  }
}
.wheel {
  z-index: map-get($z, 4);
  position: relative;
  width: 100vw;
  overflow: hidden;
  // box-shadow: ;
  filter: drop-shadow(3px 0px 5px rgba(0,0,0,0.34));
  // opacity: 0.2;
  @include breakpoint(large) {
    width: 100%;
  }
}
.wheel--shadow {
  position: absolute;
  z-index: map-get($z, 3);
  filter: blur(8px);
  overflow-x: visible;
  li {
    background-color: rgba(black, 0.3);
  }
  @include breakpoint(xmedium down) { 
    top: 0;
    right: 0;
    left: 0;
  }
  @include breakpoint(large) {
    left: 0.4em;
    right: 0.4em;
    top: 0;
  }
}
.wheel, .wheel--shadow {
  // height: 300px;
  height: 32vh;
  // background-color: pink;
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  // overflow: hidden;
  li {
    // padding: 0.25em 0;
    flex: 0 0 33.333vw;
    position: relative;
    transition: clip-path 100ms linear;
    display: flex;
    justify-content: center;
    align-items: center;
    border-left: 2px solid white;
    border-right: 2px solid white;
    overflow: hidden;
    img {
      transition: all 600ms ease;
      // max-width: 276px;
      opacity: 0.5;
      transform: scale(0.8);
      margin: 0;
    }
    div.in {
      h2 {
        animation: scale-in-center 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
      }
    }
    &:nth-child(4) {
      img {
        opacity: 1;
        transform: scale(1);
      }
    }
    &.Breakfast {
      background-color: $yellow;
    }
    &.Snack {
      background-color: $red;
    }
    &.Entree, &.Dinner {
      background-color: $blue;
    }
    &.Dessert {
      background-color: $green;
    }
  }
  @include breakpoint(xmedium down) {
    li {
      padding: 0 0.25em;
      // border-left: 1px solid white;
      // border-right: 1px solid white;
      img {
        max-width: 276px;
      }
      &:nth-child(3) {
        clip-path: $clipPosLeft;
        &.active.up {
          clip-path: $clipPosLeftOut;
        }
        &.active.down {
          clip-path: $clipPosZero;
        }
      }
      &:nth-child(4) {
        clip-path: $clipPosZero;
        &.active.up {
          clip-path: $clipPosLeft;
        }
        &.active.down {
          clip-path: $clipPosRight;
        }
      }
      &:nth-child(5) {
        clip-path: $clipPosRight;
        &.active.up {
          clip-path: $clipPosZero;
        }
        &.active.down {
          clip-path: $clipPosRightOut;
        }
      }
    }
  }
  @include breakpoint(large) {
    flex-direction: column;
    // width: 300px;
    height: 100vh;
    min-height: $minHeight;
    // justify-content: stretch;
    li {
      flex: 1 0 20vh;
      min-height: $minHeight/5;
      border-left: none;
      border-right: none;
      border-top: 2px solid white;
      border-bottom: 2px solid white;
      &:nth-child(2) {
        clip-path: $clipPosTwo;
        border-top: none;
        &.active.up {
          clip-path: $clipPosTwoOut;
          // animation: outer-clip-top-up 500ms ease both;
        }
        &.active.down {
          // filter: blur(4px);
          clip-path: $clipPosThree;
          // animation: outer-clip-top-down 500ms ease both reverse;
        }
      }
      &:nth-child(3) {
        clip-path: $clipPosThree;
        &.active.up {
          clip-path: $clipPosTwo;
          // animation: inner-clip-top-up 500ms ease both;
        }
        &.active.down {
          clip-path: $clipPosZero;
          // animation: inner-clip-top-down 500ms ease both reverse;
        }
      }
      &:nth-child(4) {
        &.active.up {
          // animation: middle-clip-up 500ms ease both;
          clip-path: $clipPosThree;
        }
        &.active.down {
          // animation: middle-clip-down 500ms ease both;
          clip-path: $clipPosFive;
        }
      }
      &:nth-child(5) {
        clip-path: $clipPosFive;
        &.active.up {
          // animation: inner-clip-bottom-up 500ms ease both;
          clip-path: $clipPosZero;
        }
        &.active.down {
          // animation: inner-clip-bottom-down 500ms ease both;
          clip-path: $clipPosSix;
        }
      }
      &:nth-child(6) {
        clip-path: $clipPosSix;
        border-bottom: none;
        &.active.up {
          // animation: outer-clip-bottom-up 500ms ease both;
          clip-path: $clipPosFive;
          // filter: blur(1);
        }
        &.active.down {
          // animation: outer-clip-bottom-down 500ms ease both;
          clip-path: $clipPosSixOut;
        }
      }
    }
  }
}

.wheel__image {
  width: 32vw;
  height: auto;
  // border: 1px solid red;
  &.new.done {
    animation: scale-in-center 200ms ease;
  }
  @include breakpoint(large) {
    width: 24vw;
  }
}

.wheel__category {
  position: absolute;
  bottom: 10%;
  color: white;
  text-transform: uppercase;
  font-size: em(18);
  @include breakpoint(xmedium down) {
    left: 0;
    right: 0;
    text-align: center;
  }
  @include breakpoint(large) {
    right: 8%;
  }
}
.wheel__category--red {
  color: $red;
}

/**
 * ----------------------------------------
 * animation scale-in-center
 * ----------------------------------------
 */
@keyframes scale-in-center {
  0% {
    transform: scale(0);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

</style>
